module.exports = __webpack_public_path__ + "static/media/westinchennai13.54e32982.jpg";